import apiServices from 'config/apiServiceApiGateway'
import {
  PaginationType,
  QueryType,
  SegmentType,
  SegmentGroupType,
  SegmentGroupABType,
} from 'features/Segmentation/@types/Segment'

const { Get, Put, Post, Delete } = apiServices

export type GetSegmentListResponseType = {
  data: SegmentType[]
  pagination: PaginationType
}

export type GetSegmentListRequestType = { params: Partial<Omit<QueryType, 'pagination'>> }

export const getSegmentList = ({ params }: GetSegmentListRequestType) =>
  Get<GetSegmentListResponseType, true>({ params, url: '/segmentation/internal/v2/segment' })

export type PutUpdateStatusSegmentRequestType = {
  segmentId: string
  status: boolean
}

export type PutUpdateStatusSegmentResponseType = {
  data: {
    message: string
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export const putUpdateStatusSegment = ({ segmentId, status }: PutUpdateStatusSegmentRequestType) =>
  Put<PutUpdateStatusSegmentResponseType, true>({
    url: `/segmentation/internal/v2/segment/${segmentId}/status`,
    data: {
      status,
    },
  })

export type PostCreateSegmentGroupRequestType = {
  name: string
  segment_groups: {
    segment_id: number
    segment_name: string
  }[]
  segment_start_date: string
  segment_end_date: string
}

export type PostCreateSegmentGroupResponseType = {
  data: {
    message: string
  }
}

export const postCreateSegmentGroup = (data: PostCreateSegmentGroupRequestType) =>
  Post<PostCreateSegmentGroupResponseType, true>({
    url: '/segmentation/internal/v1/segment-group',
    data,
  })

export type GetSegmentGroupListResponseType = {
  data: SegmentGroupType[]
  pagination: PaginationType
}
export type GetSegmentGroupListRequestType = { params: Partial<Omit<QueryType, 'pagination'>> }

export const getSegmentGroupList = ({ params }: GetSegmentListRequestType) =>
  Get<GetSegmentGroupListResponseType, true>({
    params,
    url: '/segmentation/internal/v1/segment-group',
  })

export type PutUpdateSegmentGroupType = {
  segmentGroupId: string
  data: PostCreateSegmentGroupRequestType
}
export const putUpdateSegmentGroup = ({ data, segmentGroupId }: PutUpdateSegmentGroupType) =>
  Put<PutUpdateStatusSegmentResponseType, true>({
    url: `/segmentation/internal/v1/segment-group/${segmentGroupId}`,
    data,
  })

export type PutUpdateStatusSegmentGroupRequestType = {
  segmentGroupId: string
  status: boolean
}

export const putUpdateStatusSegmentGroup = ({
  segmentGroupId,
  status,
}: PutUpdateStatusSegmentGroupRequestType) =>
  Put<PutUpdateStatusSegmentResponseType, true>({
    url: `/segmentation/internal/v1/segment-group/${segmentGroupId}/status`,
    data: { status },
  })

export type DeleteSegmentRequestType = {
  segmentId: string
}

export type DeleteSegmentResponseType = {
  message: string
}

export const deleteSegment = ({ segmentId }: DeleteSegmentRequestType) =>
  Delete<DeleteSegmentResponseType>({
    url: `/segmentation/internal/v2/segment/${segmentId}`,
  })

export type DeleteSegmentGroupRequestType = {
  segmentGroupId: string
}
export const deleteSegmentGroup = ({ segmentGroupId }: DeleteSegmentGroupRequestType) =>
  Delete<{ message: string }>({
    url: `/segmentation/internal/v1/segment-group/${segmentGroupId}`,
  })

export type DeleteSegmentGroupABRequestType = {
  segmentGroupABId: string
}

export const deleteSegmentGroupAB = ({ segmentGroupABId }: DeleteSegmentGroupABRequestType) =>
  Delete<{ message: string }>({
    url: `/segmentation/internal/v1/segment-ab-group/${segmentGroupABId}`,
  })

export type GetSegmentGroupABRequestType = { params: Partial<Omit<QueryType, 'pagination'>> }

export type GetSegmentListGroupABResponseType = {
  data: SegmentGroupABType[]
  pagination: PaginationType
}
export const getSegmentGroupAB = ({ params }: GetSegmentGroupABRequestType) =>
  Get<GetSegmentListGroupABResponseType, true>({
    url: '/segmentation/internal/v1/segment-ab-group',
    params,
  })

export type PutUpdateStatusSegmentGroupABRequestType = {
  segmentGroupABId: string
  status: boolean
}

export const putUpdateStatusSegmentGroupAB = ({
  segmentGroupABId,
  status,
}: PutUpdateStatusSegmentGroupABRequestType) =>
  Put<{ message: string }>({
    url: `/segmentation/internal/v1/segment-ab-group/${segmentGroupABId}/status`,
    data: { status },
  })
